import { Head, Link } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { LifetimeDealForm, type LifetimeDealFormValues } from "@/components/LifetimeDealForm"
import { PageHeader } from "@/components/PageHeader"

interface DealDetail extends LifetimeDealFormValues {
  id: number
  redemptions_count: number
}

export default function AdminLifetimeDealEdit({ deal }: { deal: DealDetail }) {
  return (
    <>
      <Head title={`Edit ${deal.name}`}>
        <meta name="description" content={`Edit the ${deal.name} lifetime deal.`} />
        <meta property="og:title" content={`Edit ${deal.name}`} />
        <meta property="og:description" content={`Edit the ${deal.name} lifetime deal.`} />
      </Head>
      <AdminShell>
        <PageHeader
          title={`Edit ${deal.name}`}
          description={`${deal.redemptions_count} redemptions so far.`}
          actions={
            <Link href="/admin/lifetime_deals" className="text-sm text-ink-muted no-underline hover:text-ink-display">
              Back to deals
            </Link>
          }
        />
        <LifetimeDealForm
          deal={deal}
          action={`/admin/lifetime_deals/${deal.id}`}
          method="patch"
          submitLabel="Save changes"
        />
      </AdminShell>
    </>
  )
}
